import App from "../layouts/App";
import villagehomeJpg from "/villagehome.jpg";

export default function Services() {
	return (
		<App>
			<main className="AboutMain">
				<div className="AboutDiv">
					<h4>SHOW UP! - SIGN UP! - PUT UP!</h4>
					<hr className="Divider"></hr>
					<p className="AboutPara"></p>
					<div className="img-container">
						<div className="img-box">
							<img src={villagehomeJpg} alt="Village Home" />
						</div>
					</div>
				</div>
			</main>
		</App>
	);
}
